// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oeos-title b{display:inline-block;margin-right:5px}.oeos-title span{opacity:.8}.oeos-title svg{margin-bottom:-5px}.oeos-title svg+b{margin-left:5px}.theme--dark.v-application{background-color:var(--v-background-base,#121212)!important}.theme--light.v-application{background-color:var(--v-background-base,#fff)!important}", ""]);
// Exports
module.exports = exports;
